import { cn } from '../../lib/cn';
import { BRAND_NAME } from '../../brand';

export interface LogoProps {
  className?: string;
  /** Overrides the accessible name; ignored when `decorative` is set. */
  title?: string;
  /**
   * Set when the brand name is already written next to the mark: the mark is
   * then hidden from screen readers instead of repeating that name.
   */
  decorative?: boolean;
}

/**
 * The Globerce mark, inlined so it scales with the surrounding text and needs
 * no network request. The same file is served from /globerce-logo.svg as the
 * browser-tab icon.
 */
export const Logo = ({ className, title, decorative = false }: LogoProps) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn('size-6 shrink-0', className)}
    {...(decorative
      ? { 'aria-hidden': true, focusable: false }
      : { role: 'img', 'aria-label': title ?? BRAND_NAME })}
  >
    <rect width="40" height="40" rx="20" fill="#BE4343" />
    <path
      d="M35.0422 16.9625C35.044 17.2151 34.9708 17.4625 34.8319 17.6734C34.693 17.8843 34.4945 18.0492 34.2617 18.1471C34.0289 18.2451 33.7723 18.2717 33.5244 18.2236C33.2765 18.1754 33.0484 18.0548 32.8692 17.8768C32.69 17.6989 32.5676 17.4718 32.5176 17.2242C32.4677 16.9766 32.4924 16.7198 32.5886 16.4862C32.6848 16.2527 32.8482 16.053 33.058 15.9125C33.2679 15.772 33.5147 15.697 33.7673 15.697C33.9342 15.6957 34.0998 15.7275 34.2544 15.7906C34.4091 15.8536 34.5497 15.9466 34.6682 16.0643C34.7867 16.1819 34.8807 16.3218 34.9449 16.476C35.0091 16.6302 35.0422 16.7955 35.0422 16.9625Z"
      fill="white"
    />
    <path
      d="M10.6871 15.887C11.3201 14.3586 10.5944 12.6064 9.06613 11.9733C7.5379 11.3403 5.78586 12.066 5.15284 13.5944C4.51983 15.1228 5.24555 16.875 6.77378 17.5081C8.30201 18.1411 10.054 17.4153 10.6871 15.887Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3815 33.457C27.8126 33.457 33.8369 27.4321 33.8369 20C33.8369 12.5679 27.8126 6.54301 20.3815 6.54301C12.9503 6.54301 6.92603 12.5679 6.92603 20C6.92603 27.4321 12.9503 33.457 20.3815 33.457ZM20.3815 33.9292C28.0735 33.9292 34.3091 27.6929 34.3091 20C34.3091 12.3071 28.0735 6.07083 20.3815 6.07083C12.6895 6.07083 6.45386 12.3071 6.45386 20C6.45386 27.6929 12.6895 33.9292 20.3815 33.9292Z"
      fill="white"
    />
  </svg>
);
